import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';

export const REPORT_TYPE_OPTIONS = [
  { value: 'products_with_dp_gmv', label: 'Products with DP GMV' },
  { value: 'mfr_products_only', label: 'MFR products only' },
];

function MfrProductGmvReportModal({ show, onHide, onSubmit, submitting }) {
  const [selectedTypes, setSelectedTypes] = useState([]);

  const handleToggle = value => {
    setSelectedTypes(prev =>
      prev.includes(value) ? prev.filter(type => type !== value) : [...prev, value],
    );
  };

  const handleHide = () => {
    setSelectedTypes([]);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide}>
      <Modal.Header closeButton>
        <Modal.Title>Select report types</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {REPORT_TYPE_OPTIONS.map(option => (
            <Form.Check
              type="checkbox"
              key={option.value}
              id={`report-type-${option.value}`}
              label={option.label}
              checked={selectedTypes.includes(option.value)}
              onChange={() => handleToggle(option.value)}
              className="mb-2"
            />
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={selectedTypes.length === 0 || submitting}
          onClick={() => onSubmit(selectedTypes)}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

MfrProductGmvReportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

export default MfrProductGmvReportModal;
